import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-cp-date-picker',
  imports: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: ` <p>cp-date-picker works!</p> `,
  styles: ``,
})
export class CpDatePickerComponent {}
